/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  AgentPolicySelector,
  AgentPolicySelector$Outbound,
  AgentPolicySelector$outboundSchema,
} from "./agentpolicyselector.js";

/**
 * Grant effect; direct agent policy is allow-only
 */
export const UpdateAgentPolicyGrantFormEffect = {
  Allow: "allow",
} as const;
/**
 * Grant effect; direct agent policy is allow-only
 */
export type UpdateAgentPolicyGrantFormEffect = ClosedEnum<
  typeof UpdateAgentPolicyGrantFormEffect
>;

export type UpdateAgentPolicyGrantForm = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  /**
   * Grant effect; direct agent policy is allow-only
   */
  effect: UpdateAgentPolicyGrantFormEffect;
  /**
   * Direct policy grant identifier
   */
  grantId: string;
  /**
   * Agent-runtime-safe scope to grant
   */
  scope: string;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
};

/** @internal */
export const UpdateAgentPolicyGrantFormEffect$outboundSchema: z.ZodMiniEnum<
  typeof UpdateAgentPolicyGrantFormEffect
> = z.enum(UpdateAgentPolicyGrantFormEffect);

/** @internal */
export type UpdateAgentPolicyGrantForm$Outbound = {
  agent_id: string;
  effect: string;
  grant_id: string;
  scope: string;
  selector: AgentPolicySelector$Outbound;
};

/** @internal */
export const UpdateAgentPolicyGrantForm$outboundSchema: z.ZodMiniType<
  UpdateAgentPolicyGrantForm$Outbound,
  UpdateAgentPolicyGrantForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    effect: UpdateAgentPolicyGrantFormEffect$outboundSchema,
    grantId: z.string(),
    scope: z.string(),
    selector: AgentPolicySelector$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      grantId: "grant_id",
    });
  }),
);

export function updateAgentPolicyGrantFormToJSON(
  updateAgentPolicyGrantForm: UpdateAgentPolicyGrantForm,
): string {
  return JSON.stringify(
    UpdateAgentPolicyGrantForm$outboundSchema.parse(updateAgentPolicyGrantForm),
  );
}
